<script>

    import Header from '../global/header.svelte';
    import OpeningHours from '../global/openingHours.svelte';
    import { onMount } from 'svelte';
    import Loader from '../widgets/loader.svelte'
    import FilterNav from '../widgets/filterNav.svelte'


    import { getContext } from 'svelte';
    import { fly } from 'svelte/transition';
    
    import Dialog from '../widgets/dialog.svelte';

    let loading = false;
    let fetchingPosition = false;
    let locationInput = false;
    let stores = [];
    let storeDistances;
    let store;
    let stores_raw;

    /* === Get the initial input set for Google Place Finder OnMount */
    onMount( () => {
       locationInput = document.getElementById('userAddress');
	});

    /* === Simple function to get users location */
    function getLocation() {
        loading = true;
        fetchingPosition = true;
        
        if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
        } else {

            showDialog("Geolocation Not Supported", "Your device does not support this feature");

            fetchingPosition = false;
            loading = false;
        }

        return false;
    }



    
    /* === Geolocation Callback Success */
    function geoSuccess(position) {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        fetchingPosition = false;
        locationInput.value = lat + " " + lng;
        getLocations( lat, lng );
    }

    /* === Geolocation Callback Error */
    function geoError(err) {
        loading = false;

        alert('Cannot connect to your location.\n\nPlease check your location setting within your device settings and ensure your have internet access.');
         
         //alert(`ERROR(${err.code}): ${err.message}`);
    }

    /* === Initialise the map */
    function findData() {

      

        fetchingPosition = true;
        loading = true;

        if( !locationInput.value ) {
             alert('Please enter a town or postcode.');
        }
    
        fetch('https://liveapi.yext.com/v2/accounts/1343457/locations/geosearch?location=' + locationInput.value + '&limit=20&api_key=cad21e5756c03eacef2c0dad870ed243&v=20200322')
        .then( response => response.json())
        .then( (json) => {
            storeDistances = json.response.locationDistances;
            stores = json.response.locations;
            stores_raw = json.response.locations;
            
              loading = false;
              fetchingPosition = false;

              
                dataLayer.push({
                    'event':'CustomEvent',
                    'category':'Store Finder Search',
                    'action':'Search completed',
                    'label': locationInput.value
                });
               

              
              dataLayer.push({
                'event':'CustomEvent',
                'category':'Store Finder Search',
                'action':'Search results displayed',
                'label': stores.length 
               });

             
            

         })
         .catch( err => {
               loading = false;
             fetchingPosition = false; 
             console.log( err );
              showDialog("Error", "We where unable to fetch the information you require");
        }) 
       
    }


    /* === Call API via fetch with our Long and Lat Location */
    function getLocations( geometryLong, geometryLat ) {

       fetch('https://liveapi.yext.com/v2/accounts/1343457/locations/geosearch?location=' +  geometryLong + ',' + geometryLat + '&limit=20&api_key=cad21e5756c03eacef2c0dad870ed243&v=20200322')
        .then( response => response.json())
        .then( (json) => {
            storeDistances = json.response.locationDistances;
            stores = json.response.locations;
            stores_raw = json.response.locations;
             
              loading = false;
            fetchingPosition = false;
         })
         .catch( err => {
               loading = false;
             fetchingPosition = false; 
      
             showDialog("Error", "We where unable to fetch the information you require");
        }) 
       
    }

    

    /* ===== Dialog Handler */ 
    const { open } = getContext('simple-modal');

    const onCancel = (text) => {
		name = '';
		status = -1;
	}
	
	const onOkay = (text) => {
		name = text;
		status = 1;
	}

    const showDialog = (title, message) => {

        if( !title ) title="Login Error";
        if( !message) message="Your credentials did not match those on the server.";

		open(
			Dialog,
			{
                title: title,
				message: message,
                hasForm: true,
                onCancel,
				onOkay
			},
			{
				closeButton: false,
                closeOnEsc: false,
                closeOnOuterClick: false,
			}
	  );
    };
    



    /* === Set Our Store */ 
    function loadStore( oStore ) {
        console.log( oStore );

        

         dataLayer.push({
            'event':'CustomEvent',
            'category':'View Store',
            'action': oStore.locationName,
            'label':'Click'
        });

        

        store = oStore;
    }

    function closeArticle() {
        store = "";
    }

    function addProtocol( url ) {
        return url.replace("http://", "https://");
    }

    function getDefaultImage( title ) {
        var _title = title.toLowerCase();
        if( _title.indexOf("funeral") ) {
            return 'funeral-placeholder.jpg';
        } else {
            return 'store-placeholder.jpg';
        }
    }


    function findDistance( id ) {

        let dist = "n/a";

  

        let distance = storeDistances.filter(function(store){
             if( store.id == id ) {
                dist = store.distanceMiles.toFixed(2);          
             }
        })

     

        return dist;
    }

    function filterStores( event ) {

        let selectedFilter = event.detail.text;
        if( selectedFilter ) {
            if( selectedFilter == "all") {
                _stores = stores_raw;
            }
            if( selectedFilter == "food" ) {
                var _stores = stores_raw.filter(f => f.locationName.indexOf('Food') > -1);
           
            }
            if( selectedFilter == "fc" ) {
                var _stores = stores_raw.filter(f => f.locationName.indexOf('Funeralcare') > -1);
                
            }

            stores = _stores;

            
        }

    }


 
</script>


<svelte:head>
    <title>Store Finder Page</title>
</svelte:head>

<style>

form {
    display: flex;
    justify-content: space-between;
}

form input {
    width: 90%;
    margin-right: 1em;
    background: none;
    border: none;
    border-bottom: 3px solid rgba(255,255,255,.3); 
    color: #fff;
}

:-moz-placeholder,
::-webkit-input-placeholder,
::placeholder,
:-ms-input-placeholder,
::-ms-input-placeholder { 
    color: #fff;
}

form button {
    background: #00627d;
    border-radius: 20px;
    width: 150px;
    color: #fff;
    border: none;
}

button {
    min-height: 40px;
}

figure {
    margin: 0;
    height: 30vh;
    overflow: hidden;
}

figure img {
    object-fit: cover;
    width: 100%;
}

    .store-single {
        z-index: 1111;
        position: fixed;
       
        left: 0;
        bottom: -100%;
        width: 100%;
        height: 100%;
        -webkit-animation: slide 0.5s forwards;
        -webkit-animation-delay: .5s;
        animation: slide 0.5s forwards;
        animation-delay: .5s;
    }

    .location-button {
        max-width: 50px;
        margin-left: 15px;
        background-color: rgba(0,98,125, .4 );
    }

    .location-button svg {
        width: 20px;
    }

    @-webkit-keyframes slide {
        100% { bottom: 0; }
    }

    @keyframes slide {
        100% { bottom: 0; }
    }

    .store-single {
        padding: 0;
         height: 100vh;
        
         overflow: hidden;
    }

    .store-single h1 {
       
        font-size: 25px;
         font-size: 2.5rem;
         font-weight: 300;
         margin-bottom: 10px;
    }

    address {
        font-style: normal;
    }

    .store-single > div {
        overflow-y: scroll;
        height: 100%;
        background: #00627d; /* Old browsers */
        background: -moz-linear-gradient(-45deg,  #00627d 0%, #00a7ae 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(-45deg,  #00627d 0%,#00a7ae 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(135deg,  #00627d 0%,#00a7ae 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
       
    }

    aside h2 {
        color: var(--brand-color);
    }

    aside ul {
     
        background: rgba(255,255,255,.3);
        padding: 5%;
        border-radius: 10px;
    }

     aside ul li {
         margin-bottom: 1em;
     }

     aside ul li:last-child {
         margin-bottom: 0;
     }

    figure img {
        width: 100%;
        height: 100%;
    }

    .store-single article {
        padding: 5%;
    }
    @media screen and ( min-width: 550px ) {
        .meta {
            margin-top: 2em;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }
    }
    .meta aside {
        flex-basis: 48%;
        margin-bottom: 2em;
    }


     .item {
        background: var(--dark-color);
        padding: 24px;
        position: relative;
        border-radius: 10px;
        margin-bottom: 1em;
    }
    .item:after {
        content:'';
        width: 12px;
        height: 21px;
        background: url('../svg/angle-right.svg');
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 10px;
    }
    .item h2, .item h3 {
        font-weight: 500;
    }
   .item h2{
        margin:0 0 .25em 0;
    }
    .item h3 {
        font-size: 13px;
        font-size: 1.3rem;
        color: var(--brand-color);
        margin: 0;
    }
    .close {
        position: fixed;
        top: 5%;
        left: 5%;
    }
   


</style>



<Header title="Stores" url="/" /> 

<section>
    <div>
        
        <form>
            <input onfocus="this.value=''" type="text" id="userAddress" value="Town, Postcode" name="" />
            {#if fetchingPosition}
                <button>Loading</button>
            {:else}
                 <button on:click|preventDefault={findData}>Go</button>
                <button class="location-button" on:click|preventDefault={getLocation}><svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m12 7.875c-2.278125 0-4.125 1.846875-4.125 4.125s1.846875 4.125 4.125 4.125 4.125-1.846875 4.125-4.125-1.846875-4.125-4.125-4.125zm0 6c-1.0340625 0-1.875-.8409375-1.875-1.875s.8409375-1.875 1.875-1.875 1.875.8409375 1.875 1.875-.8409375 1.875-1.875 1.875zm11.25-3h-2.3278125c-.5085937-4.06921875-3.7279687-7.28859375-7.7971875-7.7971875v-2.3278125c0-.414375-.335625-.75-.75-.75h-.75c-.414375 0-.75.335625-.75.75v2.3278125c-4.06921875.50859375-7.28859375 3.72796875-7.7971875 7.7971875h-2.3278125c-.414375 0-.75.335625-.75.75v.75c0 .414375.335625.75.75.75h2.3278125c.50859375 4.0692188 3.72796875 7.2885938 7.7971875 7.7971875v2.3278125c0 .414375.335625.75.75.75h.75c.414375 0 .75-.335625.75-.75v-2.3278125c4.0692188-.5085937 7.2885938-3.7284375 7.7971875-7.7971875h2.3278125c.414375 0 .75-.335625.75-.75v-.75c0-.414375-.335625-.75-.75-.75zm-11.25 7.875c-3.721875 0-6.75-3.028125-6.75-6.75s3.028125-6.75 6.75-6.75 6.75 3.028125 6.75 6.75-3.028125 6.75-6.75 6.75z" fill="#fff"/></svg></button>
            {/if}
        </form>

        

        {#if !loading}

            {#if stores.length > 0}

                <FilterNav on:message={filterStores} />


                {#each stores as store}
                    <article class="item" on:click={loadStore(store)}>
                        <h2>{store.locationName}</h2>
                        <h3>{store.address} {store.city} {store.zip}</h3>   
                        <h4>Distance: {findDistance(store.id)} miles</h4>
                    </article>
                {/each}
            {:else}
                Please enter your postcode
            {/if}

        {:else}
             <Loader msg="Finding your local store and funeral home" />
        {/if}


        

    </div>

    {#if store} 
        <div class="store-single">


            <div>

                <a class="close" href="#close" on:click={closeArticle}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12.387" height="21.667" viewBox="0 0 12.387 21.667">
                        <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back" d="M14.985,17.024l8.2-8.192A1.548,1.548,0,0,0,20.99,6.646L11.7,15.928a1.545,1.545,0,0,0-.045,2.135l9.327,9.346a1.548,1.548,0,1,0,2.193-2.187Z" transform="translate(-11.251 -6.194)" fill="#fff"/>
                    </svg>
                </a> 

                <figure> 
                    {#if store.facebookCoverPhoto }
                        <img src="{ addProtocol(store.facebookCoverPhoto.url) }" alt="Store Image" />
                    {:else}
                        <img src="{ getDefaultImage( store.locationName ) }" alt="Store Image" />
                    {/if}
                </figure>
                <article>
                <h1>{store.locationName}</h1>
                <address>{store.address}, {store.city}, {store.zip}</address>
                
                <div class="meta">
                   
                    <aside>
                        <h2>Opening Hours</h2>
                         <OpeningHours standard={store.hours} holiday={store.holidayHours}/>
                    </aside>
           
                    {#if store.products }
                    <aside>
                        <h2>Products</h2>
                        <ul> 
                            {#each store.products as product}
                                <li>{product}</li>
                            {/each}
                        </ul>
                    </aside>
                    {/if }
                    {#if store.services }
                    <aside>
                        <h2>Services</h2>
                        <ul> 
                            {#each store.services as service}
                                <li>{service}</li>
                            {/each}
                        </ul>
                    </aside>
                    {/if }
                </div>

                <a class="btn btn--dark" target="_blank" href="https://www.google.com/maps/dir/current+location/{store.yextRoutableLat},{store.yextRoutableLng}"><img width="15" src="svg/pin.svg" alt="My Card" /> Directions</a>
        
                {#if store.phone}
                    <a class="btn btn--dark" href="tel:+44{store.phone}"><img width="15" src="svg/phone.svg" alt="My Card" /> Call Store</a>
                {/if}

                {#if store.facebookPageUrl}
                     <a class="btn btn--light" target="_blank" href="{store.facebookPageUrl}"><img  src="svg/f.svg"  /> Store Facebook Page</a>
                {/if}

                </article>
            </div>
        </div>
        {/if}

</section>
